export default __webpack_public_path__ + "static/woman2-fd7add919863cdaaf6520a40da2698f6.png";